import { Link, useMediaQuery } from "@mui/material";
import { useEffect, useReducer, useState } from "react";
import { useDispatch } from "react-redux";
import { setUnstakeModalOpen, useStakingSliceActions } from "src/store/features/staking.slice";
import { use2FACheck } from "src/features/trade/hooks/use2FACheck";
import { useHistory } from "react-router-dom";
import { Grid } from "@mui/material";
import { Box } from "@mui/material";
import { Stack } from "@mui/material";
import {
  CalendarIcon,
  SmallTdRoobertNormalDark,
  SmallThRoobertMediumDark,
  StakeButton,
  StyledDatePicker,
  StyledDivider,
  StyledPagination,
  StyledTable,
  StyledTableDataLabel,
  StyledTableRow,
  TableSwitch,
  UnstakeButton,
} from "./staking-styled-components";
import { FilterIcon } from "./staking-styled-components";
import { StyledEntertextspan } from "./staking-styled-components";

import { InfoContentStyle } from "./staking-styled-components";
import { SmallSpanRoobertMediumDark } from "./staking-styled-components";
import { SmallSpanRoobertNormalDark } from "./staking-styled-components";
import { StyledContainedbuttons } from "./staking-styled-components";
import { StyledStakedspan } from "./staking-styled-components";

import { DcaContainer as StyledShadowBoxContainer } from "src/components/dca/styled-components/DcaContainer";
import InfoIcon from "src/icons/portfolio/InfoIcon";
import { FilterSelection } from "../dca/StrategiesTable";
import { dateFormatter } from "src/utils/helpers/DateAndTimeHelpers";
import TransactionDateRangePicker from "../transactions/TransactionDateRangePicker";
import { mockCoinsAvailableForStaking, mockHistoryTableData } from "./mock";
import { SummaryMobileCard } from "./SymmaryMobileCard";
import { HistoryMobileCard } from "./HistoryMobileCard";
import {
  StyledHelperContainer,
  StyledHelperLabel,
  StyledHelperTitle,
  StyledRedHelperText,
} from "../dca/styled-components/TableStyledComponents";

export const SummaryAndHistoryTable = () => {
  // redux
  const { setStakeModalOpen, setExportedSummarySnackbarOpen } = useStakingSliceActions();
  const dispatch = useDispatch();

  // Filter
  const [filterToggle, setFilterToggle] = useReducer((state) => !state, false);
  const [tabSelected, setTabSelected] = useState<"summary" | "history">("summary");
  const [openDates, setOpenDates] = useState<boolean>(false);
  const [startDate, setStartDate] = useState<number | undefined>(undefined);
  const [endDate, setEndDate] = useState<number | undefined>(undefined);
  const [summarySortyBy, setSummarySortyBy] = useState<number>(0);
  const [summaryCurrency, setSummaryCurrency] = useState<number>(0);
  const [historyCurrency, setHistoryCurrency] = useState<number>(0);
  const [historyStatus, setHistoryStatus] = useState<number>(0);

  // Media query
  const isMobile = useMediaQuery("(max-width: 600px)");

  // 2FA
  const { is2FAEnabled } = use2FACheck();

  // History
  const history = useHistory();

  // Local variables
  const userHasNoStakedAssets = mockHistoryTableData.length === 0;

  // If selected filter is clear, set to 0
  useEffect(() => {
    if (summarySortyBy === 3) setSummarySortyBy(0);
    if (historyStatus === 3) setHistoryStatus(0);
  }, [summarySortyBy, historyStatus]);

  // Handle change date
  const handleChangeDate = (start: number, end: number) => {
    setStartDate(start);
    setEndDate(end);
  };

  return (
    <Grid container mt={2} mb={3}>
      <Grid item xs={12}>
        <StyledShadowBoxContainer style={{ padding: isMobile ? "12px" : "16px" }}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}>
            {/* Table Switch */}
            <Stack direction={"row"} gap={1} alignItems={"center"}>
              <TableSwitch
                active={tabSelected === "summary"}
                onClick={() => setTabSelected("summary")}>
                Summary
              </TableSwitch>
              <TableSwitch
                active={tabSelected === "history"}
                onClick={() => setTabSelected("history")}>
                History
              </TableSwitch>
            </Stack>

            {/* Filter and Export */}
            <Stack
              direction={"row"}
              gap={1}
              alignItems={"center"}
              display={{ xs: "none", md: "flex" }}>
              <StyledEntertextspan active={filterToggle} onClick={setFilterToggle}>
                Filter <FilterIcon />
              </StyledEntertextspan>
              <StyledEntertextspan onClick={() => dispatch(setExportedSummarySnackbarOpen(true))}>
                Export CSV
              </StyledEntertextspan>
            </Stack>
          </Box>

          {/* Divider */}
          <Box my={2}>
            <StyledDivider />
          </Box>

          {/* If 2FA disabled display alert card */}
          {!is2FAEnabled && (
            <Box mt={4}>
              <InfoContentStyle style={{ background: "#FEFCF8" }}>
                <SmallSpanRoobertMediumDark style={{ fontWeight: 600, textAlign: "left" }}>
                  <Stack direction={"row"} gap={1} alignItems={"center"}>
                    <InfoIcon /> Action Required
                  </Stack>
                </SmallSpanRoobertMediumDark>
                <Stack
                  direction={isMobile ? "column" : "row"}
                  gap={2}
                  width={"100%"}
                  alignContent={"center"}
                  justifyContent={"space-between"}>
                  <SmallSpanRoobertMediumDark
                    style={{ fontWeight: 400, textAlign: "left", maxWidth: "780px" }}>
                    For your security Caleb & Brown requires you to enable two factor authentication
                    (2FA). Once enabled, you'll be able to lodge withdrawal requests, add new
                    addresses to your account, stake and place trades.
                  </SmallSpanRoobertMediumDark>
                  <div
                    style={{
                      height: isMobile ? "auto" : "24px",
                      width: isMobile ? "auto" : "87px",
                    }}>
                    <StakeButton
                      variant={isMobile ? "mobile" : undefined}
                      onClick={() => history.push("/settings/security")}
                      style={{
                        padding: isMobile ? "12px 8px" : "4px 8px",
                        fontWeight: 600,
                        fontSize: isMobile ? "16px" : "14px",
                        whiteSpace: "nowrap",
                      }}>
                      Enable 2FA
                    </StakeButton>
                  </div>
                </Stack>
              </InfoContentStyle>
            </Box>
          )}

          {/* Mobile Filter and Export */}
          <Stack
            direction={"row"}
            gap={1}
            alignItems={"center"}
            py={2}
            display={{ xs: "flex", md: "none" }}>
            <StyledEntertextspan
              active={filterToggle}
              onClick={setFilterToggle}
              style={{ padding: "7px 11.5px" }}>
              Filter <FilterIcon />
            </StyledEntertextspan>
            <StyledEntertextspan
              style={{ padding: "7px 11.5px" }}
              onClick={() => dispatch(setExportedSummarySnackbarOpen(true))}>
              Export CSV
            </StyledEntertextspan>
          </Stack>

          {/* Filter Section */}
          {tabSelected === "summary" && (
            <Stack
              direction={isMobile ? "column" : "row"}
              justifyContent={"space-between"}
              alignItems={isMobile ? "stretch" : "center"}
              pt={1}
              display={filterToggle ? "flex" : "none"}>
              <Box
                display={"flex"}
                flexDirection={isMobile ? "column" : "row"}
                gap={0.5}
                alignItems={isMobile ? "flex-start" : "center"}
                width={isMobile ? "100%" : "auto"}>
                <SmallSpanRoobertNormalDark>Sort by</SmallSpanRoobertNormalDark>
                <FilterSelection
                  variant={isMobile ? "mobile" : undefined}
                  filterState={summarySortyBy}
                  setFilterState={setSummarySortyBy}
                  allStatuses={["Available Balance", "Total Staked", "APY", "Clear"]}
                />
                <SmallSpanRoobertNormalDark>Select currency</SmallSpanRoobertNormalDark>
                <FilterSelection
                  variant={isMobile ? "mobile" : undefined}
                  filterState={summaryCurrency}
                  setFilterState={setSummaryCurrency}
                  allStatuses={["Ethereum", "Solana", "Cardano", "All"]}
                />
              </Box>
              <Box>
                {isMobile ? (
                  <Box width={"100%"} display={"flex"} justifyContent={"center"} mt={2} mb={2.5}>
                    <StyledContainedbuttons>Clear All</StyledContainedbuttons>
                  </Box>
                ) : (
                  <StyledStakedspan style={{ cursor: "pointer", textDecoration: "underline" }}>
                    <SmallSpanRoobertNormalDark>Clear All</SmallSpanRoobertNormalDark>
                  </StyledStakedspan>
                )}
              </Box>
            </Stack>
          )}

          {tabSelected === "history" && (
            <Stack
              direction={isMobile ? "column" : "row"}
              justifyContent={"space-between"}
              alignItems={isMobile ? "stretch" : "center"}
              pt={1}
              display={filterToggle ? "flex" : "none"}>
              <Box
                display={"flex"}
                flexDirection={isMobile ? "column" : "row"}
                gap={1}
                alignItems={isMobile ? "flex-start" : "center"}
                width={isMobile ? "100%" : "auto"}>
                <Box
                  display={"flex"}
                  flexDirection={isMobile ? "column" : "row"}
                  gap={1}
                  alignItems={isMobile ? "flex-start" : "center"}
                  width={isMobile ? "100%" : "auto"}>
                  <StyledStakedspan>Select Currency</StyledStakedspan>
                  <FilterSelection
                    variant={isMobile ? "mobile" : undefined}
                    filterState={historyCurrency}
                    setFilterState={setHistoryCurrency}
                    allStatuses={["Ethereum", "Solana", "Cardano", "All"]}
                  />
                </Box>

                <Box
                  display={"flex"}
                  flexDirection={isMobile ? "column" : "row"}
                  gap={1}
                  alignItems={isMobile ? "flex-start" : "center"}
                  width={isMobile ? "100%" : "auto"}>
                  <StyledStakedspan>Dates</StyledStakedspan>
                  <StyledDatePicker
                    variant={isMobile ? "mobile" : undefined}
                    onClick={() => setOpenDates(true)}>
                    <SmallSpanRoobertMediumDark>
                      {(() => {
                        const placeholder = isMobile ? "Select Date Range" : "Select";
                        if (startDate && endDate) {
                          return `${dateFormatter(
                            new Date(startDate),
                            false,
                            true,
                          )} - ${dateFormatter(new Date(endDate), false, true)}`;
                        }
                        if (startDate && !endDate) {
                          return `${dateFormatter(new Date(startDate), false, true)} - Today`;
                        }
                        if (!startDate && endDate) {
                          return `Until ${dateFormatter(new Date(endDate), false, true)}`;
                        }
                        return placeholder;
                      })()}
                    </SmallSpanRoobertMediumDark>
                    <CalendarIcon />
                  </StyledDatePicker>
                  <TransactionDateRangePicker
                    openCalendar={openDates}
                    setOpenCalendar={setOpenDates}
                    callback={handleChangeDate}
                  />
                </Box>

                <Box
                  display={"flex"}
                  flexDirection={isMobile ? "column" : "row"}
                  gap={1}
                  alignItems={isMobile ? "flex-start" : "center"}
                  width={isMobile ? "100%" : "auto"}>
                  <StyledStakedspan>Status</StyledStakedspan>
                  <FilterSelection
                    variant={isMobile ? "mobile" : undefined}
                    filterState={historyStatus}
                    setFilterState={setHistoryStatus}
                    allStatuses={["Completed", "Pending", "Failed", "All"]}
                  />
                </Box>
              </Box>

              {isMobile ? (
                <Box width={"100%"} display={"flex"} justifyContent={"center"} mt={2} mb={2.5}>
                  <StyledContainedbuttons>Clear All</StyledContainedbuttons>
                </Box>
              ) : (
                <StyledStakedspan style={{ cursor: "pointer", textDecoration: "underline" }}>
                  Clear All
                </StyledStakedspan>
              )}
            </Stack>
          )}

          {/* Mobile table content */}
          <Box display={{ xs: "block", md: "none" }}>
            {tabSelected === "summary" && (
              <Box>
                {mockCoinsAvailableForStaking.map((coin: string) => {
                  return <SummaryMobileCard key={coin} coin={coin} />;
                })}
              </Box>
            )}
            {tabSelected === "history" && (
              <Box>
                {mockHistoryTableData.map((coin: string) => {
                  return <HistoryMobileCard key={coin} coin={coin} />;
                })}
              </Box>
            )}
          </Box>

          {/* Desktop Summary Table content */}
          {tabSelected === "summary" && (
            <Box display={{ xs: "none", md: "block" }}>
              <StyledTable>
                <thead>
                  <StyledTableRow>
                    <SmallThRoobertMediumDark>Coin</SmallThRoobertMediumDark>
                    <SmallThRoobertMediumDark>Available</SmallThRoobertMediumDark>
                    <SmallThRoobertMediumDark>Min to Stake</SmallThRoobertMediumDark>
                    <SmallThRoobertMediumDark>Total Staked</SmallThRoobertMediumDark>
                    <SmallThRoobertMediumDark>APY</SmallThRoobertMediumDark>
                    <SmallThRoobertMediumDark>Next Reward</SmallThRoobertMediumDark>
                    <SmallThRoobertMediumDark style={{ textAlignLast: "center" }}>
                      Action
                    </SmallThRoobertMediumDark>
                  </StyledTableRow>
                </thead>
                <tbody>
                  {mockCoinsAvailableForStaking.map((coin: string) => {
                    return (
                      <StyledTableRow key={coin}>
                        <SmallTdRoobertNormalDark style={{ fontWeight: 500 }}>
                          {coin} <br /> <StyledTableDataLabel>X SOL</StyledTableDataLabel>
                        </SmallTdRoobertNormalDark>
                        <SmallTdRoobertNormalDark>
                          $ SOL <br /> <StyledTableDataLabel>000</StyledTableDataLabel>
                        </SmallTdRoobertNormalDark>
                        <SmallTdRoobertNormalDark>
                          000 SOL <br />
                        </SmallTdRoobertNormalDark>
                        <SmallTdRoobertNormalDark>
                          000 SOL <br /> <StyledTableDataLabel>000</StyledTableDataLabel>
                        </SmallTdRoobertNormalDark>
                        <SmallTdRoobertNormalDark>2 - 4%</SmallTdRoobertNormalDark>
                        <SmallTdRoobertNormalDark>$2234.34</SmallTdRoobertNormalDark>
                        <SmallTdRoobertNormalDark style={{ textAlignLast: "center" }}>
                          <Stack direction={"row"} gap={1} justifyContent={"center"}>
                            <StakeButton onClick={() => dispatch(setStakeModalOpen(true))}>
                              Stake
                            </StakeButton>
                            <UnstakeButton onClick={() => dispatch(setUnstakeModalOpen(true))}>
                              Unstake
                            </UnstakeButton>
                          </Stack>
                        </SmallTdRoobertNormalDark>
                      </StyledTableRow>
                    );
                  })}
                </tbody>
              </StyledTable>
            </Box>
          )}

          {/* Desktop History Table content */}
          {tabSelected === "history" && (
            <Box display={{ xs: "none", md: "block" }}>
              {userHasNoStakedAssets ? (
                <Box display={"flex"} flexDirection={"column"} textAlign={"center"} width="100%">
                  <StyledTable>
                    <thead>
                      <StyledTableRow>
                        <SmallThRoobertMediumDark>Date</SmallThRoobertMediumDark>
                        <SmallThRoobertMediumDark>Coin</SmallThRoobertMediumDark>
                        <SmallThRoobertMediumDark>Amount</SmallThRoobertMediumDark>
                        <SmallThRoobertMediumDark>Action</SmallThRoobertMediumDark>
                        <SmallThRoobertMediumDark style={{ textAlignLast: "right" }}>
                          Status
                        </SmallThRoobertMediumDark>
                      </StyledTableRow>
                    </thead>{" "}
                  </StyledTable>

                  <StyledStakedspan
                    style={{ fontSize: "16px", color: "#5C6469", padding: "100px 0px" }}>
                    You currently have no assets staked. Start staking and track it here.
                  </StyledStakedspan>
                  <StyledHelperContainer>
                    <StyledHelperTitle>{`Not sure how to stake?`} </StyledHelperTitle>
                    <StyledHelperLabel>
                      {`Speak to your broker here or view our quick links below`}
                    </StyledHelperLabel>
                    <Link target="_blank" underline="none" href="TODO: SUPPORT ARTICLE">
                      <StyledRedHelperText text="How to stake?" />
                    </Link>
                    <Link target="_blank" underline="none" href="TODO: SUPPORT ARTICLE">
                      <StyledRedHelperText text="How to unstake?" />
                    </Link>
                  </StyledHelperContainer>
                </Box>
              ) : (
                <Box>
                  <StyledTable>
                    <thead>
                      <StyledTableRow>
                        <SmallThRoobertMediumDark>Date</SmallThRoobertMediumDark>
                        <SmallThRoobertMediumDark>Coin</SmallThRoobertMediumDark>
                        <SmallThRoobertMediumDark>Ammount</SmallThRoobertMediumDark>
                        <SmallThRoobertMediumDark>Action</SmallThRoobertMediumDark>
                        <SmallThRoobertMediumDark style={{ textAlignLast: "right" }}>
                          Status
                        </SmallThRoobertMediumDark>
                      </StyledTableRow>
                    </thead>

                    <tbody>
                      {mockHistoryTableData.map((coin: string) => {
                        return (
                          <StyledTableRow key={coin}>
                            <SmallTdRoobertNormalDark>10 July 2025</SmallTdRoobertNormalDark>
                            <SmallTdRoobertNormalDark>
                              <span style={{ fontWeight: 500 }}>{coin}</span> <br />{" "}
                              <StyledTableDataLabel>Icon SOL</StyledTableDataLabel>
                            </SmallTdRoobertNormalDark>
                            <SmallTdRoobertNormalDark>Value Abb</SmallTdRoobertNormalDark>
                            <SmallTdRoobertNormalDark>Staked</SmallTdRoobertNormalDark>
                            <SmallTdRoobertNormalDark style={{ textAlignLast: "right" }}>
                              Completed
                            </SmallTdRoobertNormalDark>
                          </StyledTableRow>
                        );
                      })}
                    </tbody>
                  </StyledTable>
                </Box>
              )}
            </Box>
          )}

          <Box
            justifyItems={"center"}
            mt={2}
            display={{ xs: userHasNoStakedAssets ? "none" : "block" }}>
            <StyledPagination
              count={2}
              page={1}
              onChange={() => {}}
              showFirstButton
              showLastButton
            />
          </Box>
        </StyledShadowBoxContainer>
      </Grid>
    </Grid>
  );
};
